import {getUserDetailsIfLoggedIn} from '../redux/user/userActions';

export const checkUserOnLoad = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if(user) {
        return;
    } else {
        getUserDetailsIfLoggedIn().then();
    }
};
